import { command, Command } from "@lookiero/messaging";

const PLAY_GAME = "play_game";

interface PlayGamePayload {
  readonly aggregateId: string;
  readonly like: boolean;
  readonly view: string;
}

interface PlayGame extends Command<typeof PLAY_GAME>, PlayGamePayload {}

interface PlayGameFunction {
  (payload: PlayGamePayload): PlayGame;
}

const playGame: PlayGameFunction = ({ aggregateId, ...payload }) => ({
  ...command({ aggregateId, name: PLAY_GAME }),
  ...payload,
});

export { PLAY_GAME, playGame };
export type { PlayGame };
